import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSpinnerModule, Size } from 'ngx-spinner';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [NgxSpinnerModule, CommonModule],
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent implements OnChanges {
  @Input() fullScreen = true;
  @Input() size: Size = 'medium';
  @Input() viewText = true;
  @Input() icon = 'ball-spin';
  @Input() name = 'full_' + Math.random();
  @Input() loadingText = '';

  @Input() show: boolean | undefined = false;
  _show: boolean | undefined = false;

  ngOnChanges(changes: SimpleChanges): void {
    const showSpinnerChange = changes['show'];
    if (showSpinnerChange) {
      if (showSpinnerChange.isFirstChange()) {
        this._show = !this.show;
        setTimeout(() => (this._show = this.show));

        return;
      }

      this._show = this.show;
    }
  }
}
